import type { TestRunSource } from '../models/test-run.model';

/**
 * Pipeline-Laeufe tragen als Umgebung ihren Branch (`ObservedRunPersister`).
 * Tabelle und Filter lesen davon dasselbe heraus — den Typ vor dem ersten
 * Schraegstrich — und muessen sich darin einig sein, sonst filtert die Auswahl
 * nach etwas anderem, als die Zeile anzeigt.
 */

/**
 * Ticketkennung im Branchnamen — Projektkuerzel, Bindestrich, Nummer. Bewusst
 * eine Heuristik: der Branch ist Freitext, niemand erzwingt die Konvention.
 * Greift sie nicht, bleibt es beim Typ allein statt bei einem falschen Treffer.
 */
const TICKET = /[A-Za-z][A-Za-z0-9]*-\d+/;

/**
 * Traegt dieser Lauf statt einer Umgebung einen Branch? Nur Pipeline-Laeufe tun das —
 * eine Umgebung mit Schraegstrich (`kunde/abnahme`) bleibt eine Umgebung.
 */
export function isBranchEnvironment(source: TestRunSource): boolean {
  return source === 'PIPELINE';
}

/** `feature/NEX-1-neu` → `feature`; ein Branch ohne Typ (`develop`) ergibt null. */
export function branchType(branch: string): string | null {
  const slash = branch.indexOf('/');
  return slash > 0 ? branch.slice(0, slash) : null;
}

/** Was in die Tabellenzelle passt: `feature/NP20-1148-geburtsdatum` → `feature NP20-1148`. */
export function branchSummary(branch: string): string {
  const type = branchType(branch);
  if (!type) {
    return branch;
  }
  const ticket = TICKET.exec(branch.slice(type.length + 1));
  return ticket ? `${type} ${ticket[0]}` : type;
}

/**
 * Filterwert eines Branch-Typs. Der Schraegstrich bleibt stehen: an ihm
 * erkennt der Server, dass er als Praefix suchen soll und nicht auf Gleichheit
 * (`TestRunSpecifications#environmentMatches`).
 */
export function branchTypeFilterValue(branch: string): string {
  const type = branchType(branch);
  return type ? `${type}/` : branch;
}

/**
 * Beschriftung eines Filterwerts. Der Schraegstrich gehoert zur Abfrage, nicht
 * zur Anzeige — im Filter steht `feature`, gesucht wird nach `feature/`.
 */
export function environmentFilterLabel(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value;
}
